import makeStyles from "@mui/styles/makeStyles";
export var useImageCropperStyles = makeStyles(function (theme) { return ({
    imageDialog: {
        position: "relative",
        background: theme.design.colors.waz_white,
        borderRadius: 8,
        boxShadow: "0px 3px 6px ".concat(theme.design.colors.waz_black99),
        width: "100%",
        maxWidth: 1128,
        height: "max-content",
        zIndex: 10,
        fontFamily: theme.design.font.openSans,
    },
    imageDialogHeadingContainer: {
        padding: theme.spacing(2, 2, 2, 3.5),
        width: "100%",
        boxSizing: "border-box",
    },
    imageDialogHeading: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    imageDialogTitle: {
        color: theme.design.colors.waz_black,
        fontSize: theme.typography.fontSize + 4,
        fontWeight: theme.typography.fontWeightMedium,
    },
    imageDialogIcon: {
        color: theme.design.colors.waz_grey200,
        fontSize: theme.typography.fontSize + 4,
        width: "21px",
        height: "21px",
        cursor: "pointer",
    },
    imageDialogComponentsContainer: {
        display: "flex",
        width: "100%",
    },
    imageDialogCropSection: {
        width: "60%",
        borderTop: "1px solid ".concat(theme.design.colors.waz_grey300),
        borderRight: "1px solid ".concat(theme.design.colors.waz_grey300),
        background: theme.design.colors.waz_grey6,
        borderRadius: "0 0 0 8px",
        padding: theme.spacing(2, 5.5),
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        height: 520,
    },
    imageDialogConfigSection: {
        width: "40%",
        borderTop: "1px solid ".concat(theme.design.colors.waz_grey300),
        position: "relative",
    },
    image: {
        width: "100%",
        objectFit: "contain",
        height: 554,
    },
    configTabs: {
        display: "flex",
        justifyContent: "space-evenly",
        padding: theme.spacing(0, 3),
        gap: theme.spacing(4),
        borderBottom: "1px solid ".concat(theme.design.colors.waz_grey300),
    },
    configTab: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        padding: "20px 0",
        width: "100%",
    },
    activeConfigTab: {
        borderBottom: "2px solid ".concat(theme.design.colors.waz_primary100),
    },
    tabName: {
        color: theme.design.colors.waz_grey100,
        fontSize: theme.typography.fontSize + 2,
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: "22px",
        textTransform: "uppercase",
    },
    activeTabName: {
        color: theme.design.colors.waz_primary100,
    },
    btn: {
        position: "absolute",
        left: "calc((100% - 132px)/2)",
        bottom: 25,
        textAlign: "center",
        padding: theme.spacing(1, 2),
        fontSize: theme.typography.fontSize + 2,
        fontWeight: "".concat(theme.typography.fontWeightRegular, " !important"),
        lineHeight: "24px",
    },
    featureImageDialog: {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        background: theme.design.colors.waz_white,
        borderRadius: 8,
        boxShadow: "0px 3px 6px ".concat(theme.design.colors.waz_black99),
        width: "100%",
        maxWidth: 746,
        height: "max-content",
        zIndex: 10,
    },
    featureImageDialogComponentsContainer: {
        display: "flex",
        width: "100%",
        flexFlow: "column nowrap",
        borderTop: "1px solid ".concat(theme.design.colors.waz_grey300),
        justifyContent: "flex-start",
        alignItems: "center",
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4.5),
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(7),
    },
    featureImageDialogHeadingContainer: {
        padding: theme.spacing(1.5, 4),
        width: "100%",
    },
    featureBtnContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingTop: theme.spacing(2),
    },
    featureBtn: {
        width: 77,
        height: 40,
        textAlign: "center",
        padding: theme.spacing(1),
        fontSize: theme.typography.fontSize - 1,
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: "24px",
    },
}); });
